<script>
export default {
  props: {
    table: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<template>
  <div>
    <b-table
      table-class="table table-centered datatable table-card-list"
      :items="table.fields"
      :fields="table.fields"
      responsive
    >
      <!-- eslint-disable -->
      <template v-for="(item, i) in table.fields" v-slot:[`cell(${item.key})`]="data">
        <b-skeleton :key="i" animation="wave" width="85%"></b-skeleton>
      </template>
    </b-table>
  </div>
</template>

<style scoped>
.b-skeleton {

  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.12);
  cursor: wait;
  -webkit-mask-image: radial-gradient(#fff, #000);
  mask-image: radial-gradient(#fff, #000);
}
.b-skeleton-text {
  height: 1rem;
  margin-bottom: 0.25rem;
  border-radius: 0.25rem;
}
</style>
